// src/pages/CourseTime/components/slides/layouts/AssessmentIntroSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import AssessIntroImage from '../../../../../assets/raz/RazPoses_0001_lets_start.png';
import { GET_APP_LOCALIZE_TEXT } from '../../../../../utils/dq_lc_service/lc_service';

// Layouts: PRE_ASSESSMENT_INTRO, POST_ASSESSMENT_INTRO
// No top progress bar / floating nav arrow for this slide (hidden in
// CourseTime.page.jsx / SlideViewer.comp.jsx) — this is the only way
// to advance past it, so the CTA lives here instead.
const AssessmentIntroSlide = ({
  slide,
  renderSpokenText,
  skipTitleSpeech,
  themeColor,
  pageLc,
  onNextSlide,
  isNextButtonDisabled
}) => (
  <S.AssessmentIntroContainer>
    <S.AssessmentIntroTopRow>
      <S.AssessmentIntroImageContainer>
        <S.AssessmentIntroImage
          src={
            slide.Images && slide.Images.length > 0
              ? (typeof slide.Images[0] === 'string' ? slide.Images[0] : slide.Images[0].url || AssessIntroImage)
              : AssessIntroImage
          }
          alt={`${slide.assessment_type === 'pre' ? 'Pre' : 'Post'} Assessment`}
        />
      </S.AssessmentIntroImageContainer>
      <S.AssessmentIntroContent>
        <S.AssessmentIntroTitle>
          <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        </S.AssessmentIntroTitle>
      </S.AssessmentIntroContent>
    </S.AssessmentIntroTopRow>
      <S.PopupButton
          themeColor={themeColor}
          onClick={onNextSlide}
          disabled={isNextButtonDisabled}
          style={{
              alignSelf: 'center',
              fontWeight: 700,
              opacity: isNextButtonDisabled ? 0.5 : 1,
              cursor: isNextButtonDisabled ? 'not-allowed' : 'pointer'
          }}
      >
        {GET_APP_LOCALIZE_TEXT(pageLc, 'uo__start_test_text')}
      </S.PopupButton>
  </S.AssessmentIntroContainer>
);

export default AssessmentIntroSlide;
